module.exports = __webpack_public_path__ + "static/media/skate-project.1ddd596f.png";